 const inPaid = (order) => {
    
      const isTodayOrLater = (dateString) => {
        const date = new Date(dateString);
        const today = new Date();
      
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
      
        return date >= today;
      };
    
      if (order?.tariff?.type === 'free' && Number(order?.class?.amount) === 0) return true; //не будет в продлить
      if (order.class_id === null) {
        if (order?.tariff?.type === 'month') return order.status_payment ? isTodayOrLater(order.next_payment_date) : false;
        if (order?.tariff?.type === 'hour' || order?.tariff?.type === 'minute') return +(order?.private_balance ?? 0) >= 0;
        else if (Number(order?.class?.amount) !== 0) {
            return true;
        }
      } else {
        return isTodayOrLater(order?.class?.classUser?.filter(classUser => classUser.user_id === order?.children_id && classUser.deleted_at == null)[0]?.next_payment_date) ?? true;
      }
      return true;
}
export default inPaid;//костыль
